
export class OperationReworkModel {
    operationId: string;
    operationDesc: string;
    totalRework: number; // total times the rework flag is there in the hanger_routing
    totalSpentReworkSecs: number; // total sum of time time of the rework spent 

    constructor( operationId: string,
        operationDesc: string,
        totalRework: number,
        totalSpentReworkSecs: number
        ) {
            this.operationId = operationId;
            this.operationDesc = operationDesc;
            this.totalRework = totalRework;
            this.totalSpentReworkSecs = totalSpentReworkSecs;
    }
}
